import { FirebaseDataService } from '../../services/firebase-data.service';

const firebaseDataService = new FirebaseDataService();

export function fetchChatgptConversions(statsObj, user, graph) {
  return new Promise((resolve, reject) => {
    try {
      firebaseDataService.getStats(statsObj, user, graph, 'barchart').subscribe((data) => {
        resolve({ data });
      });
    } catch (error) {
      reject(error);
    }
  });
}
